import { subscriptionActionTypes } from '../actions/subscriptionActions.js';
import { userActionTypes } from '../actions/userActions.js';

const initState = {
  subscribing: false,

  subscriptions: [],
  subscriptionsLoaded: false,

  memberships: [],
  membershipsLoaded: false,

  subscribedMemberships: [],
  subscribedMembershipsLoaded: false,
};

const SubscriptionReducer = (state = initState, action) => {
  switch (action.type) {
    case userActionTypes.LOGOUT:
      return initState;

    case subscriptionActionTypes.subscribeToMembershipStart:
      return { ...state, ...{ subscribing: true } };

    case subscriptionActionTypes.subscribeToMembershipSuccess:
      return { ...state, ...{ subscribing: false } };

    case subscriptionActionTypes.subscribeToMembershipFailed:
      return { ...state, ...{ subscribing: false } };

    case subscriptionActionTypes.getMembershipsSuccess:
      return {
        ...state,
        ...{
          memberships: action.memberships,
          membershipsLoaded: true,
        },
      };

    case subscriptionActionTypes.getSubscribedMembershipsSuccess:
      return {
        ...state,
        ...{
          subscribedMemberships: action.subscribedMemberships,
          subscribedMembershipsLoaded: true,
        },
      };

    case subscriptionActionTypes.getSubscriptionsStart:
      return {
        ...state,
        ...{
          subscriptionsLoaded: false,
        },
      };

    case subscriptionActionTypes.getSubscriptionsSuccess:
      return {
        ...state,
        ...{
          subscriptions: action.subscriptions,
          subscriptionsLoaded: true,
        },
      };

    case subscriptionActionTypes.getSubscriptionSuccess: {
      const { subscriptions } = state;
      const { subscription } = action;
      return {
        ...state,
        ...{
          subscriptions: subscriptions.map((sub) =>
            sub.id === subscription.id ? subscription : sub
          ),
          subscriptionsLoaded: true,
        },
      };
    }

    default:
      return state;
  }
};

export default SubscriptionReducer;
